<template>
    <div class="home-agency-user">
        <heading :title="title" tag="home-project-title"/>
        <b-row>
            <div class="col-lg-6">
                <notification-list-widget/>
            </div>
            <div class="col-lg-6">
                <message-list-widget/>
            </div>
        </b-row>
        <b-row v-if="!$user.isProgramAdmin()">
            <div class="col-sm-12">
                <project-list-widget
                    :title="'Projects Assigned as Project Manager'"
                    :filter-by-project-manager="true"
                    :show-exemptions="true"/>
            </div>
        </b-row>
        <b-row v-if="$user.isAuditor()">
            <div class="col-sm-12">
                <project-list-widget
                    :title="'Projects Assigned as Auditor'"
                    :filter-by-auditor="true"
                    :show-exemptions="true"/>
            </div>
        </b-row>
        <b-row v-if="!$user.isOwnersRepresentative()">
            <div class="col-sm-12">
                <project-list-widget
                    :title="'Agency Projects'"
                    :show-agency="false"
                    :filter-by-agency="true"
                    :show-exemptions="true"/>
            </div>
        </b-row>
    </div>
</template>

<script>

import Vue from 'vue'

export default Vue.extend({
    name: 'HomeAgencyUser',
    computed: {
        title () {
            if (this.$user.isOwnersRepresentative()) {
                return "Owner's Representative Dashboard"
            } else if (this.$user.isProgramAdmin()) {
                return 'Program Administrator Dashboard'
            }
            return 'Project Manager Dashboard'
        }
    }
})
</script>
